<div class="accordion-block" [class.accordion-block--expanded]="expanded">
  <button
    type="button"
    class="accordion-toggle"
    (click)="onToggleClick()"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="panelId"
    [disabled]="disabled"
  >
    <span class="accordion-title">{{ title }}</span>
    <span class="chevron material-symbols-outlined" [class.expanded]="expanded" aria-hidden="true"
      >keyboard_arrow_up</span
    >
  </button>
  <div
    class="accordion-panel"
    [id]="panelId"
    role="region"
    [attr.aria-label]="title + ' panel'"
    [class.open]="expanded"
    [style.maxHeight.px]="expanded ? panelHeight() : 0"
  >
    <ul *ngIf="items?.length" class="entity-list">
      <li
        *ngFor="let item of items"
        [attr.data-entity-id]="item.id"
        (click)="itemSelect.emit(item.id)"
        [class.active]="activeId === item.id"
        tabindex="0"
        (keyup.enter)="itemSelect.emit(item.id)"
        role="button"
        [attr.aria-pressed]="activeId === item.id ? 'true' : 'false'"
      >
        {{ item.name }}
      </li>
    </ul>
    <ng-content *ngIf="!items?.length"></ng-content>
  </div>
</div>
